import React, {PureComponent} from "react"

import FocusOnKeyboard, {FocusOnKeyboardProps} from "../helpers/FocusOnKeyboard"

export interface Props extends FocusOnKeyboardProps {}

class TextButton extends PureComponent<Props> {
  render() {
    const {onClick, children, ...props} = this.props
    return (
      <FocusOnKeyboard {...props} onClick={onClick}>
        {children}
      </FocusOnKeyboard>
    )
  }
}

export default TextButton
